export const getBusinessesUrl = () => '/agency/businesses';

export const getBusinessUrl = (id: number) => `/agency/businesses/${id}`;

export const getResetBusinessUrl = (id: number) => `/agency/businesses/${id}/reset`;

export const getAgencyAgentsUrl = () => '/agency/agents';
